module.exports = __webpack_public_path__ + "img/football.6e3c4146.svg";